import { render, staticRenderFns } from "./FormRoleDetails.vue?vue&type=template&id=5230bcd7&scoped=true&"
import script from "./FormRoleDetails.vue?vue&type=script&lang=js&"
export * from "./FormRoleDetails.vue?vue&type=script&lang=js&"
import style0 from "./FormRoleDetails.vue?vue&type=style&index=0&id=5230bcd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230bcd7",
  null
  
)

export default component.exports